import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT, SESSIONSTORAGE } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { base64Decoding } from "../../../common/util";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomText from "components/base/CustomText";

interface AccountAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

AccountAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function AccountAdd(props:AccountAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    const loggedInUserRole = base64Decoding(sessionStorage.getItem(SESSIONSTORAGE.USER_ROLE));

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [accountRoleCode, setAccountRoleCode] = useState("ADM");
    const [projectRoleCode, setProjectRoleCode] = useState("MGR");
    const [fullname, setFullname] = useState("");
    const [userCompanyName, setUserCompanyName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [organizationDepartment, setOrganizationDepartment] = useState("");
    const [organizationPosition, setOrganizationPosition] = useState("");
    const [userCompanyId, setUserCompanyId] = useState("");
    const [userLanguage, setUserLanguage] = useState("ko");
    const [userCompanyChangeYn, setUserCompanyChangeYn] = useState(false);
    const [emailWarnYn, setEmailWarnYn] = useState(false);
    const [passwordWarnYn, setPasswordWarnYn] = useState(false);
    const [passwordConfirmWarnYn, setPasswordConfirmWarnYn] = useState(false);
    const [fullnameWarnYn, setFullnameWarnYn] = useState(false);
    const [phoneNumberWarnYn, setPhoneNumberWarnYn] = useState(false);
    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [projectId, setProjectId] = useState('SELF');


    const [selfProjectName, setSelfProjectName] = useState<string>('');


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkAccountData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(loggedInUserRole === "ADM") {
            requestProjectData();
        }
    }, []);


    useEffect(() => {
        if(userCompanyChangeYn) {
            setUserCompanyChangeYn(false);
        }
    }, [userCompanyChangeYn]);



    useEffect(() => {
        if(userCompanyName && userCompanyId) {
            setUserCompanyId("");
            setUserCompanyChangeYn(true);
        }
    }, [userCompanyName]);


    useEffect(() => {
        if(executeAddYn) {
            executeAddAccount();
        }
    }, [executeAddYn]);


    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }

    function checkAccountData() {
        setEmailWarnYn(false);
        setPasswordWarnYn(false);
        setPasswordConfirmWarnYn(false);
        setFullnameWarnYn(false);
        setPhoneNumberWarnYn(false);
        let message = "";
        let error = false;

        if(!email) {
            message = t("MESSAGE_ACCOUNT_ADD_EMAIL_INFO_ENTER_ERROR_MESSAGE");
            setEmailWarnYn(true);
            error = true;
        }
        
        if(!password || !passwordConfirm) {
            message = t("MESSAGE_ACCOUNT_ADD_PASSWORD_INFO_ENTER_ERROR_MESSAGE");
            if(!password) {
                setPasswordWarnYn(true);
            }
            if(!passwordConfirm) {
                setPasswordConfirmWarnYn(true);
            }
            error = true;
        }
        
        if(password !== passwordConfirm) {
            message = t("MESSAGE_ACCOUNT_ADD_PASSWORD_NOT_MATCHED_ERROR_MESSAGE");
            setPasswordWarnYn(true);
            setPasswordConfirmWarnYn(true);
        }
        
        if(!fullname || !phoneNumber) {
            message = t("MESSAGE_ACCOUNT_INFO_ENTER_ERROR_MESSAGE");
            if(!fullname) {
                setFullnameWarnYn(true);
            }
            if(!phoneNumber) {
                setPhoneNumberWarnYn(true);
            }
            error = true;
        }
        
        if (!projectId && !selfProjectName) {
            message = t("INPUT_PROJECT_MESSAGE");
            error = true;
        }
        
        if(error == true)
            if(props.showMessageCb){
                props.showMessageCb(message);
        }

        return !error;
    }


    function executeAddAccount() {
        const alias = email?.split('@')[0];
        const body = {}
        body['user'] = {
            user_role_type_code: accountRoleCode,
            project_role_type_code: projectRoleCode,
            email: email,
            alias: alias ? alias : fullname,
            password: password,
            fullname: fullname,
            phone_number: phoneNumber,
            company_name: userCompanyName,
            department_name: organizationDepartment,
            department_rank: organizationPosition,
            language: userLanguage,
            sms_notify_yn: true,
            email_notify_yn: true
        };

        if (projectId && projectId === 'SELF') {
            body['project'] = {
                project_name: selfProjectName
            }
        } else {
            body['project'] = {
                project_id: projectId
            }
        }

        requests.post(PLATFORM_URL.USERS, body)

        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_ACCOUNT_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_ACCOUNT_ADD_DUPLICATED_ERROR_MESSAGE"));
            }  else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    function requestProjectData() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                let project: any[] = []

                project = response.data.items.map((v) => {
                    return {
                        value: v.project_id,
                        label: v.project_name
                    }
                })
                project.unshift({
                    value: 'SELF',
                    label: t('DIRECT_INPUT_TEXT')
                })

                setProjectList(project);
            }
        })
    }


    function selectButton(id, type){
        if(id === "AccountRoleType") {
            setAccountRoleCode(type);
        } else if (id === 'ProjectRoleType') {
            setProjectRoleCode(type);
        }
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("ACCOUNT_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("ACCOUNT_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            {
                                loggedInUserRole === "ADM" ?
                                    <Fragment>
                                        <CustomRadioBtn
                                            id={"AccountRoleType"}
                                            type={"ADM"}
                                            size={18}
                                            checked={accountRoleCode === "ADM" ? true: false}
                                            selectCb={selectButton}
                                            label={t("ADMINISTRATOR_TEXT")}
                                            labelStyle={labelStyle}
                                        />

                                        <View style={{width: 44}}/>
                                    </Fragment>
                                : null
                            }

                            <CustomRadioBtn
                                id={"AccountRoleType"}
                                type={"USR"}
                                size={18}
                                checked={accountRoleCode === "USR" ? true: false}
                                selectCb={selectButton}
                                label={t("USER_MEMBER_TEXT")}
                                labelStyle={labelStyle}
                            />
                        </View>

                        <View style={style.rowContainer}>
                            <CustomText text={t("EMAIL_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={1}
                                width={570} height={36}
                                value={email}
                                type={"text"}
                                activeYn={true}
                                inputCb={setEmail}
                                warnYn={emailWarnYn}
                                placeHolderText={t("EMAIL_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("ACCOUNT_ADD_PASSWORD_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={password}
                                type={"password"}
                                activeYn={true}
                                inputCb={setPassword}
                                warnYn={passwordWarnYn}
                                placeHolderText={t("")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("ACCOUNT_ADD_PASSWORD_CONFIRM_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={3}
                                width={570} height={36}
                                value={passwordConfirm}
                                type={"password"}
                                activeYn={true}
                                inputCb={setPasswordConfirm}
                                warnYn={passwordConfirmWarnYn}
                                placeHolderText={t("")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={4}
                                width={570} height={36}
                                value={fullname}
                                type={"text"}
                                activeYn={true}
                                inputCb={setFullname}
                                warnYn={fullnameWarnYn}
                                placeHolderText={t("FULLNAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("PHONE_NUMBER_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={5}
                                width={570} height={36}
                                value={phoneNumber}
                                type={"text"}
                                activeYn={true}
                                inputCb={setPhoneNumber}
                                warnYn={phoneNumberWarnYn}
                                placeHolderText={t("PHONE_NUMBER_ENTER_MESSAGE")}
                            />
                        </View>

                        <View style={style.rowDivContainer}/>

                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("ORGANIZATION_NAME_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={9}
                                width={570} height={36}
                                value={userCompanyName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setUserCompanyName}
                                warnYn={false}
                                placeHolderText={t("COMPANY_NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("ORGANIZATION_DEPARTMENT_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={10}
                                width={570} height={36}
                                value={organizationDepartment}
                                type={"text"}
                                activeYn={true}
                                inputCb={setOrganizationDepartment}
                                warnYn={false}
                                placeHolderText={t("DEPARTMENT_NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("ORGANIZATION_POSITION_TEXT")}
                            </Text>
                            <CustomTextInput
                                key={11}
                                width={570} height={36}
                                value={organizationPosition}
                                type={"text"}
                                activeYn={true}
                                inputCb={setOrganizationPosition}
                                warnYn={false}
                                placeHolderText={t("DEPARTMENT_RANK_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                        {
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("프로젝트 역할")}
                                </Text>

                                <Fragment>
                                    <CustomRadioBtn
                                        id={"ProjectRoleType"}
                                        type={"MGR"}
                                        size={18}
                                        checked={projectRoleCode === "MGR" ? true: false}
                                        selectCb={selectButton}
                                        label={t("ADMINISTRATOR_TEXT")}
                                        labelStyle={labelStyle}
                                    />

                                    <View style={{width: 44}}/>

                                    <CustomRadioBtn
                                        id={"ProjectRoleType"}
                                        type={"MBR"}
                                        size={18}
                                        checked={projectRoleCode === "MBR" ? true: false}
                                        selectCb={selectButton}
                                        label={t("USER_MEMBER_TEXT")}
                                        labelStyle={labelStyle}
                                    />
                                </Fragment>
                            </View>

                        }
                        <View style={style.rowContainer}>
                            <CustomText text={t("프로젝트")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={17}
                                width={300} height={36}
                                items={projectList}
                                setValue={setProjectId}
                                disable={false}
                                defaultvalue={{label:t("DIRECT_INPUT_TEXT"), value:""}}
                            />
                        </View>

                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("")}
                            </Text>
                            <CustomTextInput
                                key={11}
                                width={300} height={36}
                                value={selfProjectName}
                                type={"text"}
                                activeYn={projectId === 'SELF' ? true : false}
                                inputCb={setSelfProjectName}
                                warnYn={false}
                                placeHolderText={t("PROJECT_NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("USER_PROJECT_DESCRIBE_MESSAGE")}
                        </Text>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}